import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import 'core-js/features/string/pad-end'
import 'core-js/features/string/pad-start'
import 'core-js/features/object/from-entries'

import 'regenerator-runtime/runtime'

import { EventSourcePolyfill } from 'event-source-polyfill'

global.EventSource = EventSourcePolyfill
